export default __webpack_public_path__ + "static/media/online.c927429e.svg";